import script from "./InputListEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputListEdit.vue?vue&type=script&lang=ts&setup=true"

import "./InputListEdit.vue?vue&type=style&index=0&id=be49476a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\okuharamayo\\hoikm\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be49476a"]])

export default __exports__